import { render, staticRenderFns } from "./AIHistoryConversation.vue?vue&type=template&id=247928c2&scoped=true&"
import script from "./AIHistoryConversation.vue?vue&type=script&lang=js&"
export * from "./AIHistoryConversation.vue?vue&type=script&lang=js&"
import style0 from "./AIHistoryConversation.vue?vue&type=style&index=0&id=247928c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247928c2",
  null
  
)

export default component.exports